<script lang="ts">
  import { emojis } from "$app/constants"

  export let reactions: ReactionType[]

  reactions = [...reactions].sort((a, b) => {
    if (typeof a.created_at === "string") a.created_at = new Date(a.created_at)

    if (typeof b.created_at === "string") b.created_at = new Date(b.created_at)

    return b.created_at.getTime() - a.created_at.getTime()
  })

  let reaction = reactions[0]
  let show = false
  let container: HTMLElement | null = null

  $: reaction = reactions[0]
</script>

<div class="relative flex items-center gap-1 font-bold text-gray-700">
  {#if reaction}
    {@const emoji = emojis.find((e) => e.name === reaction.emoji)}
    {reactions.length}
    <button
      type="button"
      on:mouseenter={() => (show = true)}
      on:mouseleave={() => (show = false)}
    >
      <img src={emoji?.url} alt={emoji?.label} class="size-5" />
    </button>
  {/if}

  <div
    class="absolute bottom-8 p-2 shadow-md bg-core border rounded-md z-30 w-52"
    bind:this={container}
    class:hidden={!show}
  >
    {#each reactions as reaction}
      {@const emoji = emojis.find((e) => e.name === reaction.emoji)}
      <div class="flex items-center gap-1 whitespace-nowrap">
        <img src={emoji?.url} alt={emoji?.label} class="size-4" />
        <span>{reaction.user?.name}</span>
      </div>
    {/each}
  </div>
</div>
